import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Clock, X } from 'lucide-react';
import LoginForm from './LoginForm';

const AuthTabs: React.FC = () => {
    const [searchParams] = useSearchParams();
    
    // Verificar si viene de un registro pendiente de aprobación
    const isPendingApproval = searchParams.get('pending') === 'true';
    const [showPendingAlert, setShowPendingAlert] = useState(isPendingApproval);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-950 py-12 px-4 sm:px-6 lg:px-8">
            {/* Background decoration */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl" />
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-emerald-500/10 rounded-full blur-3xl" />
            </div>

            <div className="relative max-w-md w-full space-y-8">
                {/* Logo and Title */}
                <div className="text-center">
                    <div className="flex justify-center mb-8 px-4">
                        <img
                            src="/icons/logo letras.jpg"
                            alt="Reserberry Sport"
                            className="w-full sm:w-[400px] max-w-full h-auto"
                        />
                    </div>
                    <p className="mt-2 text-sm text-gray-400">
                        Sistema de gestión para gimnasios y clubes deportivos
                    </p>
                </div>

                {/* Alerta de Pendiente de Aprobación */}
                {showPendingAlert && (
                    <div className="bg-amber-900/30 border border-amber-600 rounded-xl p-4 flex items-start gap-3">
                        <div className="flex-shrink-0">
                            <Clock className="w-6 h-6 text-amber-400" />
                        </div>
                        <div className="flex-1">
                            <h4 className="text-amber-400 font-semibold">Cuenta Pendiente de Aprobación</h4>
                            <p className="text-amber-300/80 text-sm mt-1">
                                Tu cuenta ha sido creada pero necesita ser aprobada por el administrador. 
                                Te avisaremos cuando puedas acceder.
                            </p>
                        </div>
                        <button 
                            onClick={() => setShowPendingAlert(false)}
                            className="text-amber-400 hover:text-amber-300 flex-shrink-0"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                )}

                {/* Login Form - Clean, no tabs */}
                <div className="bg-gray-900 shadow-2xl rounded-2xl overflow-hidden border border-gray-800">
                    <div className="p-8">
                        <h2 className="text-xl font-bold text-white mb-6 text-center">
                            Iniciar Sesión
                        </h2>
                        <LoginForm />
                    </div>
                </div>

                {/* Footer with discrete business link */}
                <div className="text-center space-y-3">
                    <p className="text-sm text-gray-500">
                        ¿Necesitas ayuda?{' '}
                        <a href="mailto:navora.citas@gmail.com" className="text-amber-400 hover:text-amber-300">
                            Contacta con soporte
                        </a>
                    </p>
                    <p className="text-xs text-gray-600">
                        ¿Eres un negocio?{' '}
                        <Link to="/business-signup" className="text-gray-400 hover:text-amber-400 underline">
                            Regístrate aquí
                        </Link>
                    </p>
                    <div className="pt-2 flex justify-center gap-4 text-xs text-gray-600">
                        <Link to="/privacy" className="hover:text-gray-400">
                            Política de Privacidad
                        </Link>
                        <span>·</span>
                        <Link to="/terms" className="hover:text-gray-400">
                            Términos y Condiciones
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthTabs;
